export const FETCH_PANEL_MENU = 'FETCH_PANEL_MENU';
export const FETCH_PANEL_MENU_SUCCESS = 'FETCH_PANEL_MENU_SUCCESS';
export const FETCH_PANEL_MENU_FAILURE = 'FETCH_PANEL_MENU_FAILURE';